(function () {
    'use strict';

    angular.module('app').controller('AccountingInvoiceImportController', AccountingInvoiceImportController);

    AccountingInvoiceImportController.$inject = [
        'AccountingService',
        '$routeParams',
        'toastr',
        'Request',
        'AccountingInvoiceImportTableService',
        '$location',
        '$uibModal'
    ];

    function AccountingInvoiceImportController(
        AccountingService,
        $routeParams,
        toastr,
        Request,
        AccountingInvoiceImportTableService,
        $location,
        $uibModal
    ) {

        const vm = this;
        vm.downloadTemplate = downloadTemplate;
        vm.importCSV = importCSV;
        vm.id = $routeParams.id;

        function downloadTemplate() {
            AccountingService.Invoices.downloadImportInvoiceTemplate(success => {
                toastr.success('Template successfully downloaded', 'Success');
            }, error => {
                toastr.error(error.error.message, 'Error');
            });
        }

        function importCSV(form) {
            vm.isImporting = true;
            if(form.$invalid) {
                vm.isImporting = false;
                return;
            }
            
            AccountingService.Reconciliations.importCSV(vm.id, function(result) {
                vm.isImporting = false;
                toastr.success('Successfully Imported!');
                messageQuee();
                $location.path('/accounting/invoices/' + vm.id);
            }, function(error) {
                vm.isImporting = false;
                toastr.error(error.message || 'Try again.', 'Unable to import CSV file');
            }, vm.file)
        }

        function messageQuee(){
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/pages/accounting/modals/message-quee-modal.html',
                controller: 'MessageQueeModalController',
                controllerAs: 'vm',
                windowClass: 'full-height-modal import-shipment-modal',
                size: 'md',
                appendTo: $('body'),
                // resolve: {
                //     data:()=>{
                //         return shipmentId
                //     }
                // }
            });
        }
    }

})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingInvoiceImportController.js